import { render, staticRenderFns } from "./vendor-admin-dash.vue?vue&type=template&id=09c02334&"
import script from "./vendor-admin-dash.vue?vue&type=script&lang=ts&"
export * from "./vendor-admin-dash.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports